// extracted by mini-css-extract-plugin
export default {"wrapper":"mR-z","firstToReview":"nR-z","productCards":"oR-z","productCard":"pR-z","stars":"qR-z","hidden":"rR-z"};